import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import { Box, Typography } from '@mui/material';
import { Message } from 'models/message';
import { currentUserVar } from 'apollo/reactive-variables/user';

type ChatContentProps = {
    message: Message;
};

const ChatContent: FC<ChatContentProps> = ({ message }: ChatContentProps) => {
    const currentUser = currentUserVar();

    return (
        <Box display="flex" justifyContent={currentUser._id === message.originator ? 'flex-end' : 'flex-start'} mb={2}>
            <Box flex="0 1 auto" sx={{ maxWidth: '90%' }}>
                <Box
                    px={1}
                    py={0.5}
                    sx={{
                        bgcolor: currentUser._id === message.originator ? 'calm.dark' : 'grey.800',
                        color: '#fff',
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="body2" dangerouslySetInnerHTML={{ __html: message.message }}></Typography>
                </Box>
                <Box mr={1}>
                    <Typography variant="caption">
                        {message.originatorName.firstName} {message.originatorName.lastName}{' '}
                        {formatDate(message.createdAt, 'datetime')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
export default ChatContent;
